import MainHeader from '~/legacy/components/header';
import InternationalHeader from '~/legacy/components/international-header';
import type { Region } from '~/utils/region';

interface DynamicHeaderProps {
  region: Region;
}

export const DynamicHeader = ({ region }: DynamicHeaderProps) => {
  if (!region || region.code === 'GB') return <MainHeader />;

  return <InternationalHeader />;
};
